import { IframeBlock } from '@lighthouse/block/src/blocks'
import type { IframeBlockAbstract } from '@lighthouse/core'
import { isTextValue } from '@lighthouse/shared'
import React, { useMemo } from 'react'

import { useParseVariableWithSubscription } from '@/hooks/useParseVariable'

interface IframeBlockControllerProps extends React.ComponentPropsWithoutRef<'div'> {
    blockData: IframeBlockAbstract
}

const IframeBlockController: React.FC<IframeBlockControllerProps> = props => {
    const { blockData } = props
    const { href } = blockData.config

    const parseVariable2Field = useParseVariableWithSubscription(href)

    const value = useMemo(() => {
        if (!href) {
            return ''
        }
        const cell = parseVariable2Field(href)
        if (!cell) {
            return ''
        }

        const val = Array.isArray(cell.value) ? cell.value[0] : cell.value
        if (!isTextValue(val)) {
            return ''
        }

        return val
    }, [href, parseVariable2Field])

    return <IframeBlock value={value} {...props} />
}

export default IframeBlockController
